export const NETWORK_CONSTANTS = {
  MIN_NAME_LENGTH: 3,
  MAX_NAME_LENGTH: 20,
  DEBOUNCE_DELAY: 300,
  SLUGIFY_OPTIONS: {
    replacement: '-',
    lower: true,
    trim: true,
    remove: /[^a-zA-Z0-9- ]/g,
  },
  VALIDATION_MESSAGES: {
    REQUIRED: 'Имя сети не может быть пустым',
    URL_PATTERN: 'Имя сети может содержать только латинские буквы, цифры и дефис',
    MIN_LENGTH: 'Имя сети должно содержать минимум 3 символа',
    MAX_LENGTH: 'Имя сети должно содержать максимум 20 символов',
    NAME_TAKEN: 'Имя сети занято',
  },
  TOAST_MESSAGES: {
    SUCCESS: 'Имя сети сохранено!',
    NAME_TAKEN: 'Данное имя занято! Попробуйте еще раз!',
    VALIDATION_ERROR: 'Ошибка валидации',
    GENERAL_ERROR: 'Произошла ошибка при сохранении',
  },
};
